export enum PaymentMethod {
  CHECK = 'CHECK',
  BANK_TRANSFER = 'BANK_TRANSFER',
}
